import { getAntdApp } from '@/utils/antdApp';
import i18n from '../../i18n';

export const openDeniedDialog = () => {
    const t = i18n.t.bind(i18n);
    getAntdApp().modal.info({
        title: t('denied_dialog.title', { ns: 'common' }),
        content: t('denied_dialog.content', { ns: 'common' }),
        okText: t('denied_dialog.ok_text', { ns: 'common' }),
        okButtonProps: { style: { backgroundColor: '#1677ff', borderColor: '#1677ff', color: '#fff' } },
        closable: true,
        onOk() {
            window.open('/verification', '_blank');
        }
    });
}